module.exports = __webpack_public_path__ + "img/img-8.5abe6781.png";